exports = module.exports = require("../../../../../../.config/yarn/global/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle-switch[data-v-551addae]{height:30px;width:65px;background-color:var(--brainstorm-accent-fg);border-radius:15px;position:relative;cursor:pointer}.toggle-switch .handle[data-v-551addae]{height:26px;width:26px;border-radius:13px;background-color:var(--brainstorm-accent-fg-2);position:absolute;left:2px;top:2px;transition:transform .1s ease;will-change:transform}.toggle-switch.active .handle[data-v-551addae]{transform:translateX(35px)}", ""]);

// exports
